module.exports = __webpack_public_path__ + "static/img/bg-vip4.6d8adf61.png";